import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons/faQuestionCircle";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, Typography } from "@mui/material";
import { MprcStringToHtml } from "components/MprcStringToHtml";
import { MprcText } from "components/MprcText";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";
import { MprcButton } from "./MprcButton";

interface IProps {
    title?: React.ReactNode;
    message?: React.ReactNode;
    onClose: (result: boolean | null) => void;
    yesText?: string;
    noText?: string;
    severity?: "none" | "danger" | "question";
}

type DialogPropsType = Omit<DialogProps, "onClose">;

export const MprcConfirmDialog: React.FC<IProps & DialogPropsType> = (props) => {
    const { severity = "question", title, onClose, ...dialogProps } = props;

    const { theme } = useMprcTheme();
    const lMessage = props.message || theme.MprcConfirmDialog.message;
    const lYesText = props.yesText || theme.MprcConfirmDialog.yesText;
    const lNoText = props.noText || theme.MprcConfirmDialog.noText;

    return (
        <Dialog
            onClose={() => onClose(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth={dialogProps.maxWidth ?? "sm"}
            fullWidth
            {...dialogProps}
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>

            <DialogContent>
                <Box id="alert-dialog-description">
                    <Grid container justifyContent="center" spacing={2}>
                        {
                            !title && severity != "none" &&
                            <Grid alignSelf="flex-start">
                                <MprcText color={(severity == "question" ? "warning" : "error")}>
                                    <FontAwesomeIcon icon={severity == "question" ? faQuestionCircle : faTriangleExclamation} size="3x" />
                                </MprcText>
                            </Grid>
                        }
                        <Grid size="grow" alignSelf="center">
                            <Typography variant="body2" color="black" component="div">
                                {
                                    typeof (lMessage) == "string" || Array.isArray(lMessage)
                                        ? <MprcStringToHtml text={lMessage} splitChar={'\n'} separator={<br />} />
                                        : lMessage
                                }
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center" }}>
                <MprcButton
                    color="cancel"
                    variant="contained"
                    onClick={() => onClose(false)}
                >
                    {lNoText}
                </MprcButton>
                <MprcButton autoFocus
                    color={(severity == "question" ? "warning" : severity == "danger" ? "error" : "primary")}
                    variant="contained"
                    onClick={() => onClose(true)}
                >
                    {lYesText}
                </MprcButton>
            </DialogActions>
        </Dialog>
    );
};
